<template>
  <transition appear name="fade">
    <div class="video" :class="[playing ? 'is-playing' : '']">
      <vueVimeoPlayer
        height="100%"
        width="100%"
        ref="player"
        class="intro-video"
        :controls=false        
        
        :options="{
          autoplay:true,
          muted:true
        }"      
        video-id="564661128"
        :style="videoStyle"
        @ended="videoEnded"
      />
      <button
        :class="[playing ? 'is-playing' : '']"
        @click="
          $refs.player.play();
          $refs.player.unmute();
          playing = true;
        "
      >
        <img src="@/assets/icons/icon_button-play.svg" alt="" />
      </button>
    </div>
  </transition>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
export default {
  name: "Intro",
  components: { vueVimeoPlayer },
  watch: {},
  data: () => ({ playing: false, videoStyle: {} }),
  mounted() {
    this.adjustVideo();
    window.addEventListener("resize", this.adjustVideo);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.adjustVideo);
  },
  methods: {
    videoEnded() {
      this.$router.push('home');
    },
    adjustVideo() {
      let height = Math.max(480, window.innerHeight);
      let width = Math.max(800, window.innerWidth);
      let vw, vh;
      if (width / height > 16 / 9) {
        vw = Math.round(width);
        vh = Math.round((vw * 9) / 16);
      } else {
        vh = Math.round(height);
        vw = Math.round((vh * 16) / 9);
      }
      this.videoStyle = {
        width: vw + "px",
        height: vh + "px",
        left: (width - vw) / 2 + "px",
        right: (height - vh) / 2 + "px",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
  transition: opacity 0.5s;
  outline: none;
  border: none;
  background: none;
  color: #fff;
  z-index: 1;
  cursor: pointer;
  &.is-playing {
    opacity: 0;
    pointer-events: none;
  }
}
.video {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  &:after {
    content: " ";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background:rgba(0,0,0,0.8);
    pointer-events: none;
    transition: opacity 0.5s;
  }
  &.is-playing:after {
    opacity: 0;
  }
}
</style>
<style lang="scss">
.intro-video {
  position: absolute;
  top: 0;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
